import { EnvironmentObservabilityResponse } from '../../queries/useEnvironmentObservability';

// KIND_URL_SEGMENT maps a workload kind to its OneUptime dashboard URL
// segment (https://github.com/OneUptime/oneuptime — App/FeatureSet/Dashboard/src/Utils/RouteMap.ts).
const KIND_URL_SEGMENT: Record<string, string> = {
  Deployment: 'deployments',
  StatefulSet: 'statefulsets',
  DaemonSet: 'daemonsets',
  Pod: 'pods',
};

// buildOneUptimeUrl builds a deep link into OneUptime's Kubernetes dashboard
// for the namespace or workload currently in view, falling back to no link
// (rather than the project root) when any required ingredient is missing —
// e.g. the environment's cluster is not yet registered in OneUptime. The
// link always lands on the resource's Overview tab — OneUptime's Logs and
// Metrics tabs are client-side state, not separately addressable by URL.
export function buildOneUptimeUrl(
  data: EnvironmentObservabilityResponse,
  namespace: string,
  kind?: string,
  name?: string
): string | undefined {
  if (!data.url || !data.projectId || !data.clusterId) {
    return undefined;
  }

  const base = `${data.url}/dashboard/${data.projectId}/kubernetes/${data.clusterId}`;

  const kindSegment = kind ? KIND_URL_SEGMENT[kind] : undefined;
  if (kindSegment && name) {
    return `${base}/${kindSegment}/${encodeURIComponent(name)}`;
  }

  if (namespace) {
    return `${base}/namespaces/${encodeURIComponent(namespace)}`;
  }

  return undefined;
}
